import { render, staticRenderFns } from "./EducationInfoDetail.vue?vue&type=template&id=b1223356&scoped=true"
import script from "./EducationInfoDetail.vue?vue&type=script&lang=js"
export * from "./EducationInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./EducationInfoDetail.vue?vue&type=style&index=0&id=b1223356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1223356",
  null
  
)

export default component.exports